import { API_CONFIG } from '@/config/api';
import { httpClient } from '@/utils/httpClient';

export interface SendForMaintenanceParams {
  documentNumber: string;
  assetIds: string[];
}

export interface DocumentLink {
  generatedDocumentId: string;
  documentNumber: string | null;
  documentEntityId: string | null;
  documentEntityIdentifier: string | null;
  documentDownloadUrl: string;
}

export interface SendForMaintenanceResult {
  success: boolean;
  processedAt: string;
  documentNumber: string;
  sentCount: number;
  assetIds: string[];
  transactionId: string;
  documentDownloadUrl?: string;
  documentEntityId?: string | null;
  documentEntityIdentifier?: string | null;
  documentLinks?: DocumentLink[];
  warnings?: string[];
}

export interface ReceiveFromMaintenanceParams {
  assetIds: string[];
}

export interface ReceiveFromMaintenanceResult {
  success: boolean;
  processedAt: string;
  receivedCount: number;
  assetIds: string[];
  transactionId: string;
}

export class MaintenanceService {
  async sendForMaintenance(params: SendForMaintenanceParams): Promise<SendForMaintenanceResult> {
    return httpClient.post(`${API_CONFIG.ACTIONS_API_BASE_PATH}/maintenance/send`, {
      documentNumber: params.documentNumber,
      assetIds: params.assetIds,
    });
  }

  async receiveFromMaintenance(
    params: ReceiveFromMaintenanceParams,
  ): Promise<ReceiveFromMaintenanceResult> {
    return httpClient.post(`${API_CONFIG.ACTIONS_API_BASE_PATH}/maintenance/receive`, {
      assetIds: params.assetIds,
    });
  }
}

export const maintenanceService = new MaintenanceService();
